var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext } from 'react';
import { Collapse, TableBody, TableCell, TableRow, Checkbox, IconButton, Snackbar, } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DescriptionIcon from '@mui/icons-material/Description';
import { FileSelectionCtx, DatasetSelectionCtx, } from '../../App/ApplicationContext';
import { NestedFileTable } from './NestedFileTable';
import { DoiErrorAlert } from '../../GenericUI/Alerts';
import { getDOILink } from '../../../utils/resolveDOI';
import { resolveFilesOfDataset, } from '../../../utils/getFacetsInfo';
import { parseSize } from '../../../utils/Swirrl/sizeCalculation';
import { stableSort, getComparator } from '../../../utils/muiTableSorting';
import { OPERATION, PROJECTNAME, } from '../../../types/searchTypes';
const classes = {
    tableRow: {
        padding: '0px',
        margin: '0px',
    },
    tableCell: {
        padding: '0px',
        margin: '0px',
        lineHeight: '10px',
    },
};
export const DatasetTableBody = ({ orderBy, order, rows, page, rowsPerPage, dense, operation, searchQuery, nodes, }) => {
    const [open, setOpen] = React.useState([]);
    const [doiError, setDoiError] = React.useState(false);
    const [files, populateFiles] = React.useState([]);
    const { datasetCollection, selectDatasets } = useContext(DatasetSelectionCtx);
    const { fileCollection, selectFiles } = useContext(FileSelectionCtx);
    const esdocBaseUrl = 'https://view.es-doc.org/?client_id=climate4impact_esgfsearch&renderMethod=datasetid&project=cmip5&id=';
    const openNestedTable = (id) => __awaiter(void 0, void 0, void 0, function* () {
        if (!open.includes(id)) {
            setOpen([id]);
            return resolveFilesOfDataset(id, operation, nodes).then((result) => {
                result.fileList.forEach((resultFile) => {
                    // eslint-disable-next-line no-param-reassign
                    resultFile.parent = id;
                });
                populateFiles(result.fileList);
            });
        }
        return setOpen(open.filter((elId) => !elId));
    });
    const handleSelectionClick = (dataset, datasetCtxCollection) => {
        const selection = datasetCtxCollection.some((collItem) => collItem.id === dataset.id)
            ? datasetCtxCollection.filter((collItem) => collItem.id !== dataset.id) // Deselect and remove from ctx
            : datasetCtxCollection.concat(dataset); // Select and add to ctx
        selectDatasets(selection);
    };
    const displayDoiError = (state) => {
        setDoiError(state);
    };
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    return (React.createElement(TableBody, null,
        stableSort(rows, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((oldData, index) => {
            var _a;
            const row = oldData;
            const datasetSelected = datasetCollection.some((dataset) => dataset.id === row.id);
            const deselectDataset = () => datasetCollection.filter((dataset) => dataset.id !== row.id);
            const isRowExpanded = open.includes(row.id);
            const labelId = `enhanced-table-checkbox-${index}`;
            return (React.createElement(React.Fragment, { key: row.id },
                React.createElement(TableRow, { hover: true, role: 'checkbox', "aria-checked": datasetSelected, tabIndex: -1, key: row.id, selected: datasetSelected, sx: classes.tableRow, style: {
                        backgroundColor: isRowExpanded ? '#F5F5F5' : '#FFFFFF',
                    } },
                    React.createElement(TableCell, { padding: 'checkbox', align: 'center', sx: classes.tableCell },
                        React.createElement(Checkbox, { onClick: () => {
                                handleSelectionClick(row, datasetCollection);
                                // When selecting the (complete) dataset, remove any of its files that were sepearatly selected (if applicable).
                                selectFiles(fileCollection.filter((file) => file.parent !== row.id));
                            }, checked: datasetSelected, color: 'primary', inputProps: { 'aria-labelledby': labelId } })),
                    React.createElement(TableCell, null, operation === OPERATION.DOWNLOAD && (React.createElement(IconButton, { "aria-label": 'expand row', size: 'small', 
                        // eslint-disable-next-line @typescript-eslint/no-misused-promises
                        onClick: () => openNestedTable(row.id) }, isRowExpanded ? (React.createElement(KeyboardArrowUpIcon, null)) : (React.createElement(KeyboardArrowDownIcon, null))))),
                    React.createElement(TableCell, { style: {
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                        }, sx: classes.tableCell }, row.title),
                    React.createElement(TableCell, { style: {
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                        }, sx: classes.tableCell }, row.dataNode),
                    React.createElement(TableCell, { style: {
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                        }, sx: classes.tableCell }, (_a = row.version) !== null && _a !== void 0 ? _a : '-'),
                    row.projectName !== PROJECTNAME.CMIP5 && (React.createElement(TableCell, { style: {
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                        }, sx: classes.tableCell }, row.fileNumber)),
                    React.createElement(TableCell, { style: {
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                        }, sx: classes.tableCell }, parseSize(row.size)),
                    React.createElement(TableCell, { style: {
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                        }, sx: classes.tableCell },
                        React.createElement("div", null,
                            React.createElement(IconButton, { color: 'primary', type: 'button', onClick: 
                                // eslint-disable-next-line no-nested-ternary
                                row.projectName === PROJECTNAME.CMIP6
                                    ? () => {
                                        getDOILink(row.citationUrl, row.instanceId)
                                            .then((url) => {
                                            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                                            url && row.instanceId
                                                ? window.open(url, '_blank')
                                                : displayDoiError(true);
                                        })
                                            .catch(console.error);
                                    }
                                    : row.projectName === PROJECTNAME.CMIP5
                                        ? () => row.instanceId
                                            ? window.open(`${esdocBaseUrl}${row.instanceId}`, '_blank')
                                            : displayDoiError(true)
                                        : () => null // e.g. for CORDEX
                             },
                                React.createElement(DescriptionIcon, null)),
                            React.createElement(Snackbar, { anchorOrigin: {
                                    vertical: 'top',
                                    horizontal: 'center',
                                }, open: doiError, autoHideDuration: 5000, onClose: () => displayDoiError(false) },
                                React.createElement(DoiErrorAlert, { onClose: () => displayDoiError(false), severity: 'error' }, "Metadata link could not be resolved"))))),
                operation === OPERATION.DOWNLOAD && (React.createElement(TableRow, null,
                    React.createElement(TableCell, { style: {
                            paddingBottom: 0,
                            paddingTop: 0,
                            backgroundColor: '#f6f6f6',
                        }, colSpan: 8 },
                        React.createElement(Collapse, { in: isRowExpanded, timeout: 'auto', unmountOnExit: true },
                            React.createElement(NestedFileTable, { files: files, datasetSelected: datasetSelected, deselectDataset: deselectDataset, searchQuery: searchQuery, projectName: row.projectName })))))));
        }),
        emptyRows > 0 && (React.createElement(TableRow, { style: { height: (dense ? 33 : 53) * emptyRows } },
            React.createElement(TableCell, { colSpan: 8 })))));
};
